import { useCallback } from 'react'

import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { generateAutoFormFields } from '@/utils/builder/form-parsers'

/**
 * (Hooks) Generate Form Component Fields based on the table columns
 */
export const useFormFieldsGenerator = () => {
  const { tables } = useDbClientContext()

  const generateFormFields = useCallback(
    (formId: string, formSettings: Record<string, any>, detailTableId?: string) => {
      return generateAutoFormFields(tables, formId, formSettings, detailTableId)
    },
    [tables]
  )

  return {
    generateFormFields,
  }
}
